import { InjectionToken } from "@angular/core";
import { AccountType } from "@tatynanny/api";

export interface AppConfig {
  userType: AccountType
}

export const APP_CONFIG = new InjectionToken<AppConfig>('app.config');
